import type React from 'react';
import { ReactNotifications, Store } from 'react-notifications-component';
import { styled } from 'styled-components';

const Container = styled.div`
  width: 100%;

  & .react-notification-root {
    .notification-container-bottom-center,
    .notification-container-bottom-left,
    .notification-container-bottom-right,
    .notification-container-mobile-bottom,
    .notification-container-mobile-top,
    .notification-container-top-center,
    .notification-container-top-left,
    .notification-container-top-right {
      position: fixed;
      z-index: 8000;
    }

    .notification-container-top-center {
      transform: translateX(-50%);
      top: 20px;
      left: 50%;
    }

    .notification-container-bottom-center {
      transform: translateX(-50%);
      bottom: 20px;
      left: 50%;
    }

    .notification-container-top-left {
      left: 20px;
      top: 20px;
    }

    .notification-container-top-right {
      right: 20px;
      top: 20px;
    }

    .notification-container-bottom-left {
      left: 20px;
      bottom: 20px;
    }

    .notification-container-bottom-right {
      bottom: 20px;
      right: 20px;
    }

    .notification-container-mobile-top {
      right: 20px;
      left: 20px;
      top: 20px;
    }

    .notification-container-mobile-bottom {
      right: 20px;
      left: 20px;
      bottom: 20px;
      margin-bottom: -15px;
    }

    .notification-default,
    .notification-default .timer {
      background-color: ${({ theme }) => theme.colors.link100};
    }

    .notification-default .timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .notification-default .notification-close {
      background-color: ${({ theme }) => theme.colors.link100};
    }

    .notification-success {
      border-left: 8px solid ${({ theme }) => theme.colors.positive120};
    }

    .notification-success,
    .notification-success .timer {
      background-color: ${({ theme }) => theme.colors.positive100};
    }

    .notification-success .timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .notification-success .notification-close {
      background-color: ${({ theme }) => theme.colors.positive100};
    }

    .notification-danger {
      border-left: 8px solid ${({ theme }) => theme.colors.critical120};
    }

    .notification-danger,
    .notification-danger .timer {
      background-color: ${({ theme }) => theme.colors.critical100};
    }

    .notification-danger .timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .notification-danger .notification-close {
      background-color: ${({ theme }) => theme.colors.critical100};
    }

    .notification-info {
      border-left: 8px solid #138b9e;
    }

    .notification-info,
    .notification-info .timer {
      background-color: #17a2b8;
    }

    .notification-info .timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .notification-info .notification-close {
      background-color: #17a2b8;
    }

    .notification-warning {
      border-left: 8px solid #ce9c09;
    }

    .notification-warning,
    .notification-warning .timer {
      background-color: #eab000;
    }

    .notification-warning .timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .notification-warning .notification-close {
      background-color: #eab000;
    }

    .notification-awesome {
      border-left: 8px solid #4c3fb1;
    }

    .notification-awesome,
    .notification-awesome .timer {
      background-color: #685dc3;
    }

    .notification-awesome .timer-filler {
      background-color: ${({ theme }) => theme.colors.grey00_1};
    }

    .notification-awesome .notification-close {
      background-color: #685dc3;
    }

    @keyframes timer {
      0% {
        width: 100%;
      }

      100% {
        width: 0;
      }
    }

    .notification-item {
      display: flex;
      position: relative;
      border-radius: 3px;
      margin-bottom: 15px;
      box-shadow: 1px 3px 4px rgb(0 0 0 / 20%);
      cursor: pointer;
    }

    .notification-item .timer {
      width: 100%;
      margin-top: 10px;
    }

    .notification-item .timer,
    .notification-item .timer .timer-filler {
      height: 3px;
      border-radius: 5px;
    }

    .notification-item .notification-title {
      color: ${({ theme }) => theme.colors.grey00_1};
      font-weight: 500;
      font-size: 14px;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .notification-item .notification-message {
      color: ${({ theme }) => theme.colors.grey00_1};
      max-width: calc(100% - 15px);
      font-size: 14px;
      line-height: 150%;
      word-wrap: break-word;
      margin-bottom: 0;
      margin-top: 0;
    }

    .notification-item .notification-content {
      padding: 8px 15px;
      display: inline-block;
      width: 100%;
      min-width: 270px;
    }

    .notification-item .notification-close {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      display: inline-block;
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .notification-item .notification-close::after {
      content: '\\D7';
      position: absolute;
      transform: translate(-50%, -50%);
      color: ${({ theme }) => theme.colors.grey00_1};
      font-size: 12px;
      left: 50%;
      top: 50%;
    }

    .n-parent {
      width: 275px !important;
    }

    .notification-container-mobile-bottom .n-parent,
    .notification-container-mobile-bottom .notification-item,
    .notification-container-mobile-top .n-parent,
    .notification-container-mobile-top .notification-item {
      max-width: 100%;
      width: 100%;
    }

    .notification-container-bottom-right .n-parent,
    .notification-container-top-right .n-parent {
      margin-left: auto;
    }

    .notification-container-bottom-left .n-parent,
    .notification-container-top-left .n-parent {
      margin-right: auto;
    }

    .notification-container-mobile-bottom .n-parent,
    .notification-container-mobile-top .n-parent {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export type Containers = 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center';

export interface Dismiss {
  duration: number;
  onScreen?: boolean;
}

export interface NotificationProps {
  container: Containers;
  animationIn: [string, string];
  animationOut: [string, string];
  dismiss: Dismiss;
}

const notification: NotificationProps = {
  container: 'top-right',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 5000,
    onScreen: true,
  },
};

/**
 * This component should render on top level of the app in single instance.
 * Because we have the global notify object below.
 * We can miss some notifications if we recreate this component because store will be recreated too.
 */
export const Notification: React.FC = () => (
  <Container className='notifications'>
    <ReactNotifications />
  </Container>
);

type Log = (title: string | React.ReactNode, message: string | React.ReactNode, override?: Partial<NotificationProps>) => void;

type Notify = {
  success: Log;
  danger: Log;
  info: Log;
  default: Log;
  warning: Log;
};

const notify: Notify = {
  success: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'success',
      ...override,
    });
  },
  danger: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'danger',
      ...override,
    });
  },
  info: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'info',
      ...override,
    });
  },
  default: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'default',
      ...override,
    });
  },
  warning: (title, message, override = {}) => {
    Store.addNotification({
      ...notification,
      title,
      message,
      type: 'warning',
      ...override,
    });
  },
};

export default notify;
